import React, { Suspense } from "react";
import "../Registration/Registration.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {

  Link,

  Redirect,
} from "react-router-dom";


import Loading from "../../components/Loading";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";

import { connect } from "react-redux";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";

const Property_owner_new_registration = (props) => {
  const { frontLabelsName } = props.label;
  const { isAuthenticated, loading } = props.auth;

  // if (isAuthenticated && !loading) {
  //   return <Redirect to="/dashboard" />;
  // }
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container">
     
        <div className="main-login-new-pr align-items-center">
          
          <div className="box-new-rg">
          <h4 style={{textAlign:"center",marginBottom:"30px"}}>
                    <strong>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == 'lbl_list_your_property_for_free_on_the_rental_list'
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == 'lbl_list_your_property_for_free_on_the_rental_list'
                            )[0]['value'] || 'lbl_list_your_property_for_free_on_the_rental_list'
                          : 'lbl_list_your_property_for_free_on_the_rental_list'
                        : 'lbl_list_your_property_for_free_on_the_rental_list'}
                    </strong>
                  </h4>
            <div className="row px-4">
              <div className="box1-pr-owner col-lg-4 col-md-6 " style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                <div>
               
                <div className="img-pr-owner">
                  <img src="assets/book.svg" alt="book" />
                </div>
                <p>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_register_for_free")
                        .length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_register_for_free"
                        )[0]["value"] || "lbl_register_for_free"
                      : "lbl_register_for_free"
                    : "lbl_register_for_free"}
                </p>
                <ul>
                  <li>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_register_for_free_info"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_register_for_free_info"
                          )[0]["value"] || "lbl_register_for_free_info"
                        : "lbl_register_for_free_info"
                      : "lbl_register_for_free_info"}
                  </li>
                </ul>
                </div>
                <div className="set-ch-u2">
                  <a
                    href="http://dev.saturncube.com/property/owner10/#/"
                    target="_blank"
                    rel="noreferrer"
                    className="link-color-class mt-4"
                  >
             
                    <button className="pr-owner-main mt-4">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_register_for_free"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_register_for_free"
                            )[0]["value"] || "lbl_register_for_free"
                          : "lbl_register_for_free"
                        : "lbl_register_for_free"}
                    </button>
                  </a>
                </div>
              </div>

              <div className="box1-pr-owner col-lg-4 col-md-6" style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                <div>
                <div className="img-pr-owner">
                  <img src="assets/customer.svg" alt="book" />
                </div>
                <p>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_renters_list")
                        .length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_renters_list"
                        )[0]["value"] || "lbl_renters_list"
                      : "lbl_renters_list"
                    : "lbl_renters_list"}
                </p>
                <ul>
                  <li>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_renters_list_info1"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_renters_list_info1"
                          )[0]["value"] || "lbl_renters_list_info1"
                        : "lbl_renters_list_info1"
                      : "lbl_renters_list_info1"}
                  </li>
                  <li>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_renters_list_info2"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_renters_list_info2"
                          )[0]["value"] || "lbl_renters_list_info2"
                        : "lbl_renters_list_info2"
                      : "lbl_renters_list_info2"}
                  </li>
                </ul>
                </div>
                <a
                  href="http://dev.saturncube.com/property/owner10/#/"
                  target="_blank"
                  rel="noreferrer"
                    className="link-color-class"
                >
                  <button className="pr-owner-main mt-4">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_register")
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_register")[0][
                            "value"
                          ] || "lbl_register"
                        : "lbl_register"
                      : "lbl_register"}
                  </button>
                </a>
              </div>

              <div className="box1-pr-owner col-lg-4 col-md-12 " style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
                <div>
                <div className="img-pr-owner">
                  <img src="assets/customer-01.svg" alt="book" />
                </div>
                <p>
                  {frontLabelsName
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_arrange_your_property"
                      ).length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_arrange_your_property"
                        )[0]["value"] || "lbl_arrange_your_property"
                      : "lbl_arrange_your_property"
                    : "lbl_arrange_your_property"}
                </p>
                <ul>
                  <li>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_arrange_your_property_info"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_arrange_your_property_info"
                          )[0]["value"] || "lbl_arrange_your_property_info"
                        : "lbl_arrange_your_property_info"
                      : "lbl_arrange_your_property_info"}
                  </li>
                </ul>
                </div>
                <div className="set-ch-u2">
                  <Link to="/agency-rent" 
                    className="link-color-class">
                    <button className="pr-owner-main mt-5">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_agency-rent")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_agency-rent"
                            )[0]["value"] || "lbl_agency-rent"
                          : "lbl_agency-rent"
                        : "lbl_agency-rent"}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
  auth: state.auth,
});
export default connect(mapStateToProps, {})(Property_owner_new_registration);
